import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";
import { CircularProgress } from "@mui/material";

interface ReportCardProps {
  title: string;
  description: string;
  onDownload: () => void;
  isLoading?: boolean;
}

function ReportCard({
  title,
  description,
  onDownload,
  isLoading = false,
}: ReportCardProps) {
  return (
    <div className="flex flex-col gap-4 p-4 sm:p-6 bg-white rounded-lg shadow-md justify-between">
      <div className="flex flex-col gap-2">
        <Heading size="lg">{title}</Heading>
        <Text size="md" customVariant="muted">
          {description}
        </Text>
      </div>
      <div className="flex justify-end">
        <Button
          customVariant="secondary"
          onClick={() => {
            onDownload();
          }}
          size="md"
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Baixar CSV"
          )}
        </Button>
      </div>
    </div>
  );
}

export default ReportCard;
